import { ReactElement, cloneElement, forwardRef, useMemo } from 'react'
import { AghanimIconProps } from '@/icons'
import { Button, ButtonProps, Spinner, cn } from '@dashboard/ui'

interface ButtonIconProps extends ButtonProps {
  children: ReactElement<AghanimIconProps>
}

const iconSizeMap = new Map([
  ['xs', 14],
  ['sm', 14],
  ['md', 18],
  ['lg', 22],
])

export const ButtonIcon = forwardRef<HTMLButtonElement, ButtonIconProps>(function ButtonIcon(
  { children, className, variant, type = 'button', size = 'md', loading, ...props },
  ref,
) {
  const iconSize = useMemo(() => iconSizeMap.get(size) || 18, [size])
  return (
    <Button
      ref={ref}
      variant={variant}
      size={size}
      className={cn('px-1', className)}
      type={type}
      data-loading={loading}
      {...props}
    >
      {loading ? <Spinner size={iconSize} /> : cloneElement(children, { size: iconSize })}
    </Button>
  )
})
